// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VCharts from "v-charts";
import { Datetime } from "vue-datetime";
import VueSchoolmom from "./shared/plugin";

import "./styles/base.scss";
import "vue-datetime/dist/vue-datetime.css";
import "dayjs/locale/ko";

Vue.component("datetime", Datetime);

Vue.use(VCharts);

// custom component install
Vue.use(VueSchoolmom);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
